export default "__VITE_ASSET__Do4QdIdT__"